(function () {
    const basketViewKey = 'basket_state';
    if (!sessionStorage.getItem(basketViewKey)) {
        sessionStorage.setItem(basketViewKey, 'basket');
    }
    let buttonBasket = document?.querySelectorAll('[data-type-basket]');
    if (!buttonBasket) {
        return;
    }
    function getBasketProducts() {
        return document.querySelectorAll('#basket-item-table [data-entity="basket-item"]');
    }

    function hasRenderedProducts() {
        return getBasketProducts().length > 0;
    }

    function hasDelayedProducts() {
        return document.querySelectorAll('#basket-item-table [data-entity="basket-item"][data-delay]').length > 0;
    }

    function hasBasketProducts() {
        return document.querySelectorAll('#basket-item-table [data-entity="basket-item"]:not([data-delay])').length > 0;
    }

    function resolveCurrentView() {
        let currentView = sessionStorage.getItem(basketViewKey);
        if (!hasRenderedProducts()) {
            return currentView;
        }
        if (currentView === 'basket' && !hasBasketProducts() && hasDelayedProducts()) {
            currentView = 'delay';
            sessionStorage.setItem(basketViewKey, currentView);
        }
        if (currentView === 'delay' && !hasDelayedProducts() && hasBasketProducts()) {
            currentView = 'basket';
            sessionStorage.setItem(basketViewKey, currentView);
        }
        return currentView;
    }

    function hiddenBasketProduct() {
        getBasketProducts().forEach((item) => {
            item.classList.add('none');
        });
    }

    function setActiveButton(currentView) {
        buttonBasket.forEach((button) => {
            const buttonType = button.dataset['typeBasket'];
            button.classList.toggle('basket__items-list-header-filter-item_active', buttonType === currentView);
        });
    }

    function viewTypeProduct() {
        const basketProducts = getBasketProducts();
        if (!basketProducts.length) {
            return;
        }
        const currentView = resolveCurrentView();
        hiddenBasketProduct();
        setActiveButton(currentView);
        basketProducts.forEach((item) => {
            const isDelayed = item.hasAttribute('data-delay');
            if (currentView === 'delay' && isDelayed) {
                item.classList.remove('none');
            }
            if (currentView === 'basket' && !isDelayed) {
                item.classList.remove('none');
            }
        });
    }

    function changeBasketState(button) {
        const btnType = button.dataset['typeBasket'];
        if (btnType === 'delay' && hasRenderedProducts() && !hasDelayedProducts()) {
            sessionStorage.setItem(basketViewKey, 'basket');
            viewTypeProduct();
            return;
        }
        if (btnType === 'basket' && hasRenderedProducts() && !hasBasketProducts()) {
            sessionStorage.setItem(basketViewKey, 'delay');
            viewTypeProduct();
            return;
        }
        sessionStorage.setItem(basketViewKey, btnType);
        viewTypeProduct();
    }

    function initObserver() {
        const basketTable = document.getElementById('basket-item-table');
        if (!basketTable) {
            return;
        }
        const observer = new MutationObserver(() => {
            viewTypeProduct();
        });
        observer.observe(basketTable, {
            childList: true,
            subtree: true,
        });
    }

    function initBasketState() {
        viewTypeProduct();
        buttonBasket.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                changeBasketState(btn);
                const href = btn.getAttribute('href');
                if (href && href !== '#') {
                    window.location.href = href;
                }
            });
        });
    }
    initObserver();
    initBasketState();
})();
